import React from 'react';
import { Link } from 'react-router-dom';
import useSiteBootstrap from '../hooks/useSiteBootstrap';
import '../styles/layout-shell.css';

export default function MainFooter() {
  const site = useSiteBootstrap();
  const footerPages = site?.footer_pages || [];
  const settings = site?.settings || {};
  const year = new Date().getFullYear();

  return (
    <footer className="main-footer-shell">
      <div className="container">
        <div className="main-footer-shell__inner">
          <div className="row g-4 g-lg-5">
            <div className="col-lg-4 col-md-6">
              <div className="main-footer-shell__brand-block">
                <h6 className="main-footer-shell__brand-name">
                  {settings.site_name || 'Trainable AI Agent SaaS'}
                </h6>
                <p className="main-footer-shell__brand-text">
                  {settings.footer_text ||
                    'Trainable AI Agent SaaS for modern business. Automate support, sales, and customer engagement with scalable AI conversations.'}
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <h6 className="main-footer-shell__title">Company</h6>
              <div className="main-footer-shell__links">
                <Link to="/" className="main-footer-shell__link">
                  Home
                </Link>
                <Link to="/pricing" className="main-footer-shell__link">
                  Pricing
                </Link>
                {footerPages.map((p) => (
                  <Link
                    to={`/pages/${p.slug}`}
                    key={p.id}
                    className="main-footer-shell__link"
                  >
                    {p.title}
                  </Link>
                ))}
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <h6 className="main-footer-shell__title">Contact & Support</h6>
              <div className="main-footer-shell__contact">
                <div className="main-footer-shell__contact-item">
                  <strong>Support:</strong>{' '}
                  {settings.support_email || settings.admin_notification_email || 'N/A'}
                </div>
                <div className="main-footer-shell__contact-item">
                  <strong>Contact:</strong>{' '}
                  {settings.contact_email || settings.support_email || 'N/A'}
                </div>
                <div className="main-footer-shell__contact-item">
                  <strong>Phone:</strong> {settings.contact_phone || 'N/A'}
                </div>
              </div>
            </div>
          </div>

          <div className="main-footer-shell__bottom">
            <p className="main-footer-shell__bottom-copy">
              © {year} {settings.site_name || 'Trainable AI Agent SaaS'}. All rights reserved.
            </p>

            <div className="main-footer-shell__bottom-links">
              <Link to="/" className="main-footer-shell__bottom-link">
                Home
              </Link>
              <Link to="/pricing" className="main-footer-shell__bottom-link">
                Pricing
              </Link>
              <Link to="/login" className="main-footer-shell__bottom-link">
                Login
              </Link>
              <Link to="/signup" className="main-footer-shell__bottom-link">
                Sign up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
